module.exports = __webpack_public_path__ + "static/hiapp_loading.f1950c4c.gif";